import axios from "axios";
// for local : http://localhost:5000/api
// for render : https://abmbackend-ufed.onrender.com/api
// for railway : https://abmbackend-production.up.railway.app/api

let instance;
if (window.location.hostname === "www.abmgroupone.com") {
  instance = axios.create({
    baseURL: "https://api.abmgroupone.com/api",
  });
}else{
  instance = axios.create({
    baseURL: "https://abmbackend-3c07.onrender.com/api",
  });
}


instance.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default instance;
